const mEditionBillingPaymentMethodsModalConfigurationData = {
  mEditionBillingPaymentMethodsModalConfigurationData: {
    buttonPrimary: 'Salir',
    title: 'DATOS DE MEDIO DE PAGO'
  }
}
export default mEditionBillingPaymentMethodsModalConfigurationData
